// extracted by css-extract-rspack-plugin
export default {"disabledText":"_4b06861a"};